import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function ParentTask(props) {
  const { hasParent, onClick } = props;

  return (
    <span
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-correctiveActions"
          name={hasParent ? 'dependent.task' : 'no.dependent.task'}
        />
      )}
      className={hasParent ? 'pointer' : ''}
      onClick={() => (hasParent ? onClick() : undefined)}
    >
      <AppRemixIcon
        icon="git-commit"
        color={hasParent ? colors.primary : colors.grey300}
      />
    </span>
  );
}
